enum ConsentType
{
    Read = 0,
    Write = 1,
    SendProductNotifications = 2
}

export default ConsentType;
